import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../common';
import { Ng2DatetimePickerModule } from 'ng2-datetime-picker';
import { AuditLogApp } from './auditlog.component';
import AuditLogDialogComponent from './auditlog-dialog/auditlog-dialog.component';
import { VcaAlertsService } from '../../../common/vca-alerts';
import { AppState } from '../../../app/app.service';
import { AuthService } from '../../../app/auth/auth.service';
import { routing } from './auditlog.routes';
import { LocalStorageService } from 'ngx-webstorage';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NspUpgradeService } from '../../../publisher/src/publisher-ui/upgrade/nsp-upgrade.service';

import '../../../styles/styles.scss';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ClarityModule.forRoot(),
    VcaCommonModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    Ng2DatetimePickerModule,
    TranslateModule.forRoot(),
    routing
  ],
  declarations: [
    AuditLogApp,
    AuditLogDialogComponent,
    //...APPLICATION_DECLARATIONS
  ],
  providers: [
    //...APPLICATION_PROVIDERS,
    AppState,
    LocalStorageService,
    TranslateService,
    AuthService,
    Title,
    NspUpgradeService
  ],
  bootstrap: [ AuditLogApp ],

})
export class AuditLogAppModule {
}



// WEBPACK FOOTER //
// ./src/auditlog/src/auditlog-ui/auditlog.module.ts